import RadioButtonsGroup from '../../common/form/RadioButtonsGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import DatePicker from '../../common/form/DatePicker';
import Radio from '@material-ui/core/Radio';
import CommonSelectField from '../../common/form/CommonSelectField';
import React from 'react';
import { DATE_OPTIONS } from '../../../utils/dates-const';
import Box from '@material-ui/core/Box';

export const DATE_RANGE_CUSTOM = 'custom';
export const DATE_RANGE_SELECTED = 'selected';

export const getDataGridTranslations = (formatMessage) => {
  return {
    toolbarColumns: <FormattedMessage id="report.toolbar.columns" defaultMessage="Columns" />,
    toolbarFilters: <FormattedMessage id="report.toolbar.filters" defaultMessage="Filters" />,
    toolbarDensity: <FormattedMessage id="report.toolbar.density" defaultMessage="Density" />,
    toolbarDensityComfortable: <FormattedMessage id="report.toolbar.density.comfortable"
                                                 defaultMessage="Comfortable" />,
    toolbarDensityStandard: <FormattedMessage id="report.toolbar.density.standard" defaultMessage="Standard" />,
    toolbarDensityCompact: <FormattedMessage id="report.toolbar.density.compact" defaultMessage="Compact" />,
    filterOperatorIsNotEmpty: formatMessage({
      id: 'report.toolbar.filter.is.not.empty',
      defaultMessage: 'is not empty',
    }),
    filterOperatorIsEmpty: formatMessage({ id: 'report.toolbar.filter.is.empty', defaultMessage: 'is empty' }),
    filterOperatorEquals: formatMessage({ id: 'report.toolbar.filter.equals', defaultMessage: 'equals' }),
    filterOperatorContains: formatMessage({ id: 'report.toolbar.filter.contains', defaultMessage: 'contains' }),
    filterOperatorStartsWith: formatMessage({ id: 'report.toolbar.filter.starts.with', defaultMessage: 'starts with' }),
    filterOperatorEndsWith: formatMessage({ id: 'report.toolbar.filter.ends.with', defaultMessage: 'ends with' }),
    toolbarExport: formatMessage({ id: 'report.toolbar.export', defaultMessage: 'Export' }),
    toolbarExportCSV: formatMessage({ id: 'report.toolbar.download.csv', defaultMessage: 'Download as CSV' }),
    columnsPanelShowAllButton: formatMessage({ id: 'report.toolbar.column.show.all', defaultMessage: 'SHOW ALL' }),
    columnsPanelHideAllButton: formatMessage({ id: 'report.toolbar.column.hide.all', defaultMessage: 'HIDE ALL' }),
    columnsPanelTextFieldLabel: formatMessage({ id: 'report.toolbar.find.column', defaultMessage: 'Find column' }),
    columnsPanelTextFieldPlaceholder: formatMessage({
      id: 'report.toolbar.column.title',
      defaultMessage: 'Column title',
    }),
    filterPanelOperators: formatMessage({ id: 'report.toolbar.filter.operators', defaultMessage: 'Operators' }),
    filterPanelColumns: formatMessage({ id: 'report.toolbar.filter.column', defaultMessage: 'Column' }),
    filterPanelInputPlaceholder: formatMessage({
      id: 'report.toolbar.filter.filter.value',
      defaultMessage: 'Filter value',
    }),
    filterPanelInputLabel: formatMessage({ id: 'report.toolbar.filter.value', defaultMessage: 'Value' }),
  };
};

export function getDateRangeRadioOptions(setDateRangeOption, values, setFieldValue, dateRangeOption, classes, options = DATE_OPTIONS) {
  return <RadioButtonsGroup
    handleChange={(value) => {
      setDateRangeOption(value);
      if (value === 'selected') {
        const dateRange = options.find(dateOption => dateOption.value === values.dateRange).option;
        setFieldValue('dateFrom', dateRange.dateFrom);
        setFieldValue('dateTo', dateRange.dateTo);
      }
    }}
    value={dateRangeOption}
    options={[
      <Box key={`${DATE_RANGE_CUSTOM}wrapper`} display={'flex'} flexWrap={'wrap'} alignItems={'center'}
           justifyContent={'center'}>
        <FormControlLabel
          key={`${DATE_RANGE_CUSTOM}startDate`}
          label={
            <div className={classes.datePickersWrapper}>
              <Field
                name="dateFrom"
                label={
                  <FormattedMessage
                    id="date.field.date.from"
                    defaultMessage="Date from"
                  />}
                extraHandleChangeAction={() => setDateRangeOption(DATE_RANGE_CUSTOM)}
                component={DatePicker}
              />
              <Field
                name="dateTo"
                label={
                  <FormattedMessage
                    id="date.field.date.to"
                    defaultMessage="Date to"
                  />}
                extraHandleChangeAction={() => setDateRangeOption(DATE_RANGE_CUSTOM)}
                component={DatePicker}
              />
            </div>
          }
          value={DATE_RANGE_CUSTOM}
          control={<Radio />}
        />
        <FormControlLabel
          key={`${DATE_RANGE_CUSTOM}endDate`}
          label={
            <Field
              date
              name="dateRange"
              extraHandleChangeAction={() => setDateRangeOption(DATE_RANGE_SELECTED)}
              label={<FormattedMessage id="date.field.date.range" defaultMessage="Date range" />}
              options={options}
              component={CommonSelectField}
            />}
          value={DATE_RANGE_SELECTED}
          control={<Radio />}
        />
      </Box>,
    ]
    }
  />;
}